import { GoTrash } from "react-icons/go";
import { useEffect, useState } from "react";
import { CiSquarePlus } from "react-icons/ci";
import { Form, Button, Row, Col, InputGroup } from "react-bootstrap";
import { blogPostServices } from "../../../APIServices/GlobalManagement/BlogManagement/blogPostServices";
import { categoryServices } from "../../../APIServices/GlobalManagement/BlogManagement/categoryServices";
import { subCategoryServices } from "../../../APIServices/GlobalManagement/BlogManagement/subCategoryServices";
import BlogPostEditor from "./BlogPostEditor";
import Swal from "sweetalert2";
import UseToggle from "../../../Hooks/UseToggle";
import { FiPlus } from "react-icons/fi";
import UploadedImageModal from "../../SitePilotManagement/SitePilotIntegration/UploadedImageModal";

const UpdateBlogPost = ({ getBlogPostList, getSingleBlogPost, singleBlogPost }) => {
  const toggles = UseToggle();
  const [icon, setIcon] = useState("");
  const [tags, setTags] = useState([]);
  const [loader, setLoader] = useState(false);
  const [status, setStatus] = useState("draft");
  const [blogTitle, setBlogTitle] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [subCategoryId, setSubCategoryId] = useState("");
  const [blogCategories, setBlogCategories] = useState([]);
  const [longDescription, setLongDescription] = useState("");
  const [shortDescription, setShortDescription] = useState("");
  const [blogSubCategories, setBlogSubCategories] = useState([]);

  const updatedBlogPost = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to update this blog post?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      setLoader(true);
      let userData = {};
      userData.postId = singleBlogPost?.postId;
      userData.icon = icon
      userData.title = blogTitle;
      userData.categoryId = categoryId;
      userData.subCategoryId = subCategoryId;
      userData.status = status;
      userData.shortDescription = shortDescription;
      userData.longDescription = longDescription;
      userData.tags = tags;
      let data = await blogPostServices.updatedBlogPost(userData);
      if (data?.statusCode === 200) {
        getBlogPostList();
        getSingleBlogPost();
        clearData();
      }
      setLoader(false);
    });
  };

  const clearData = () => {
    setIcon("");
    setBlogTitle("");
    setCategoryId("");
    setSubCategoryId("");
    setShortDescription("");
    setLongDescription("");
    setTags([]);
    setStatus("draft");
    setLoader(false);
  };

  const getBlogCategoryList = async () => {
    let data = await categoryServices.getBlogCategoryList("active");
    setBlogCategories(data?.data || []);
  };

  const getBlogSubCategoryList = async () => {
    let data = await subCategoryServices.getBlogSubCategoryList(
      categoryId,
      "active",
    );
    setBlogSubCategories(data?.data || []);
  };

  const addTagsRow = () => {
    setTags([...tags, ""]);
  };

  const removeTagsRow = (index) => {
    const updated = [...tags];
    updated.splice(index, 1);
    setTags(updated);
  };

  const handleTagsChange = (index, value) => {
    const updated = [...tags];
    updated[index] = value;
    setTags(updated);
  };

  const hasEmptyTag = () => {
    return tags?.some((tag) => tag.trim() === "");
  };

  useEffect(() => {
    if (singleBlogPost) {
      setIcon(singleBlogPost?.icon || "");
      setBlogTitle(singleBlogPost?.title || "");
      setCategoryId(singleBlogPost?.categoryId || "");
      setSubCategoryId(singleBlogPost?.subCategoryId || "");
      setShortDescription(singleBlogPost?.shortDescription || "");
      setLongDescription(singleBlogPost?.longDescription || "");
      setTags(singleBlogPost?.tags || []);
      setStatus(singleBlogPost?.status);
    }
  }, [singleBlogPost]);

  useEffect(() => {
    getBlogCategoryList();
  }, []);

  useEffect(() => {
    if (categoryId) {
      getBlogSubCategoryList();
    }
  }, [categoryId]);
  return (
    <div>
      <Form>
        <div
          className="overflow-auto p-3"
          style={{ height: "calc(100vh - 169px)" }}
        >
          <Row>
            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                  Icon
                </Form.Label>
                <div title="Add Icon">
                  <Button
                    onClick={toggles.setToggle}
                    variant="light"
                    className="w-100 border hstack gap-2 justify-content-center"
                    style={{ height: 108 }}
                  >
                    {icon ? (
                      <img className="w-auto h-50" src={icon} />
                    ) : (
                      <>
                        <FiPlus /> Add Icon
                      </>
                    )}
                  </Button>
                </div>
              </Form.Group>
            </Col>
            <Col md={9}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                  Title
                </Form.Label>
                <Form.Control
                  type="text"
                  style={{ fontSize: 12 }}
                  placeholder="Enter Title"
                  value={blogTitle}
                  onChange={(e) => setBlogTitle(e.target.value)}
                />
              </Form.Group>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label
                    className="fw-bold mb-1"
                    style={{ fontSize: 13 }}
                  >
                    Status
                  </Form.Label>
                  <Form.Select
                    style={{ fontSize: 12 }}
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    <option value={"draft"}>Draft</option>
                    <option value={"published"}>Published</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col>
              <Form.Group>
                <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                  Category
                </Form.Label>
                <Form.Select
                  style={{ fontSize: 12 }}
                  value={categoryId}
                  onChange={(e) => setCategoryId(e.target.value)}
                >
                  <option value={""}>Select category</option>
                  {blogCategories?.map((item) => (
                    <option value={item?.categoryId}>{item?.name}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                  Sub Category
                </Form.Label>
                <Form.Select
                  style={{ fontSize: 12 }}
                  value={subCategoryId}
                  onChange={(e) => setSubCategoryId(e.target.value)}
                >
                  <option value={""}>Select Sub Category</option>
                  {blogSubCategories?.map((item) => (
                    <option value={item?.subCategoryId}>{item?.name}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
              Short Description
            </Form.Label>
            <Form.Control
              as="textarea"
              style={{ fontSize: 12 }}
              placeholder="Enter Short Description"
              value={shortDescription}
              onChange={(e) => setShortDescription(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
              Long Description
            </Form.Label>
            <BlogPostEditor
              editorValue={longDescription}
              setEditorValue={setLongDescription}
            />
          </Form.Group>
          <Form.Group>
            <div className="hstack gap-2">
              <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                Tags
              </Form.Label>
              <CiSquarePlus
                title="Add More"
                onClick={addTagsRow}
                className="mb-1 text-success CP"
              />
            </div>
            <Row>
              {tags?.map((tag, index) => {
                return (
                  <Col md={3} className="mb-2">
                    <InputGroup key={index}>
                      <Form.Control
                        placeholder="Enter Tag"
                        value={tag}
                        style={{ fontSize: 12 }}
                        onChange={(e) =>
                          handleTagsChange(index, e.target.value)
                        }
                      />
                      <InputGroup.Text>
                        <GoTrash
                          style={{ fontSize: 12 }}
                          className="text-danger CP"
                          title="Delete"
                          onClick={() => removeTagsRow(index)}
                        />
                      </InputGroup.Text>
                    </InputGroup>
                  </Col>
                );
              })}
            </Row>
          </Form.Group>
        </div>
        <div className="d-flex justify-content-end gap-2 p-2">
          <Button variant="light" style={{ fontSize: 12 }} onClick={clearData}>
            Cancel
          </Button>

          <Button
            disabled={
              !blogTitle ||
              !categoryId ||
              !subCategoryId ||
              !status ||
              !shortDescription ||
              !longDescription ||
              loader ||
              hasEmptyTag()
            }
            onClick={updatedBlogPost}
            style={{ fontSize: 12 }}
          >
            Save
          </Button>
        </div>
      </Form>
      <UploadedImageModal
        Show={!toggles?.toggle}
        Hide={toggles?.setToggle}
        Title={`Media Library`}
        onSelect={(icon) => setIcon(icon)}
      />
    </div>
  );
};

export default UpdateBlogPost;
